if (!customElements.get('event-pickup-toggle')) {
  customElements.define(
    'event-pickup-toggle',
    class EventPickupToggle extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('input[type="checkbox"]');
        if (this.input) {
          this.input.addEventListener('change', this.onChange.bind(this));
        }
      }

      // Section ids to re-render. Only those present on the page are swapped.
      get sectionsToRender() {
        return [
          { id: 'cart-drawer', selector: '#CartDrawer' },
          { id: 'main-cart-items', selector: '#main-cart-items' },
          { id: 'main-cart-footer', selector: '#main-cart-footer' },
          { id: 'cart-icon-bubble', selector: '#cart-icon-bubble' },
        ].filter((section) => document.querySelector(section.selector));
      }

      onChange() {
        const sections = this.sectionsToRender;
        this.errorEl = this.querySelector('.event-pickup__error');
        this.setAttribute('aria-busy', 'true');
        this.input.disabled = true;
        this.hideError();

        const body = JSON.stringify({
          attributes: { event_pickup: this.input.checked ? 'true' : 'false' },
          sections: sections.map((section) => section.id),
          sections_url: window.location.pathname,
        });

        fetch(`${routes.cart_update_url}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body,
        })
          .then((response) => response.json())
          .then((parsed) => {
            if (!parsed.sections) throw new Error('No sections returned');
            sections.forEach((section) => {
              const html = parsed.sections[section.id];
              const target = document.querySelector(section.selector);
              if (!html || !target) return;
              const fresh = new DOMParser()
                .parseFromString(html, 'text/html')
                .querySelector(section.selector);
              if (fresh) target.replaceWith(fresh);
            });
            // Success: the live toggle has been replaced by a fresh, correct
            // element rendered with the new cart state. Nothing to restore on
            // `this` (it is now detached).
          })
          .catch(() => {
            // No swap happened: this element is still live. Revert and re-enable.
            this.input.checked = !this.input.checked;
            this.input.disabled = false;
            this.removeAttribute('aria-busy');
            this.showError();
          });
      }

      showError() {
        if (this.errorEl) this.errorEl.hidden = false;
      }

      hideError() {
        if (this.errorEl) this.errorEl.hidden = true;
      }
    }
  );
}
